import React, { Component } from 'react';
import DemandeStore from "../DemandeStore"
import {observer} from "mobx-react"
import axios from "axios"
import NouveauBien from "../../../../biens/New/Routeur"
@observer
export default class Bien extends Component {
  constructor(props) {
    super(props);
    this.loadBiens = this.loadBiens.bind(this)
    this.onCreate = this.onCreate.bind(this)
    this.state = {
      biens: [],
      typesdebiens: [],
      dataBien: {},
      bien: "",
      created: false

    };
    this.loadBiens()
    this.loadTypeDeBiens()
  }
  loadBiens(){
    let {email} = DemandeStore.user
    if(email !==""){
      axios.post("/api/v1/experts/app/demandesManuels/biens",{email: email}).then((data)=>{
        this.setState({biens: data.data})
      })
    }
  }
  loadTypeDeBiens(){
    axios.get("/api/v1/typedebiens",{}).then((data)=>{
      this.setState({typesdebiens: data.data,loaded: true})
    })
  }
  onCreate(data){
    axios.post("/api/v1/experts/app/bien/add",{elements: data.elements,pieces: data.pieces,user: DemandeStore.user}).then((data)=>{
      this.loadBiens()
      this.setState({created: true})
      DemandeStore.bien = data.data.id
      window.localStorage.clear()

    }).catch((error)=>{
      alert('une erreur s\'est produite')
    })

  }
  render() {
    return (
      <div>
        <div className="row">
          <div className="col s4">
            <h2 className="center">Biens préchargés</h2>
            <select onChange={(e)=>DemandeStore.bien = e.target.value} value={DemandeStore.bien} id="" className="browser-default">
              <option value="" disabled>Choisir un bien déjà encodé</option>
              {this.state.biens.map((bien)=>(
                  <option value={bien.id} key={bien.id}>{bien.adresse} {bien.numero},{bien.cp}</option>
                ))}
            </select>
          </div>
          <div className="col s8">
              {this.state.created ? (

                  <h2 className="center">Le bien a été crée et est sélectionné</h2>
              ) : (
                <div>
                    <h2 className="center">Creer un bien</h2>
                    <NouveauBien expert={true} callBackExpert={this.onCreate}/>

                </div>
              )}
            </div>
      </div>
      </div>
    );
  }
}
